import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const fetchNftData = async () => {
  const url = `${backendUrl}/api/users/subscription-data/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    // response может быть undefined при сетевой ошибке
    if (!response) {
      throw new Error('Нет ответа от сервера');
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении NFT данных');
    }
    return await response.json();
  } catch (error) {
    // AbortError — запрос отменён из-за нового запроса, игнорируем
    if (error.name === 'AbortError') {
      return null;
    }
    console.error('Ошибка при отправке GET запроса на /api/users/subscription-data/:', error);
    throw error;
  }
};